import "normalize.css"
import "./src/styles/global.css"
import "./src/styles/fonts.css"
import "./src/styles/my-prism-theme.css"

export const shouldUpdateScroll = ({
    routerProps: { location },
    prevRouterProps,
    getSavedScrollPosition,
  }) => {
  
    if (location.hash) {
      setTimeout(() => {
          // Check if the hash starts with a number and adjust the selector accordingly
          const startsWithNumber = location.hash.match(/^#(\d)/);
          let selector;
          if (startsWithNumber) {
              // If hash starts with a number, use CSS escaping
              selector = `#\\3${startsWithNumber[1]} ${location.hash.slice(2)}`;
          } else {
              // For other cases, use the hash as is
              selector = location.hash;
          }

          const hashElement = document.querySelector(selector);
          if (hashElement) {
              hashElement.scrollIntoView();
          }
      }, 50); // Adjust this delay as needed
      return false;
  }    


    // Check if we're navigating to another page
    if (prevRouterProps) {

      // Check if it's a same-page navigation (hash change)
      if (location.pathname === prevRouterProps.location.pathname) {
        // Same page navigation (hash change), don't scroll to top
        return true;
      }
  
      // Different page navigation
      if (location.action === 'PUSH') {
        // Delay scrolling to top to ensure the page has rendered
        window.setTimeout(() => window.scrollTo(0, 0), 50);
      } else {
        // Use the saved scroll position for back/forward navigation
        const savedPosition = getSavedScrollPosition(location);
        if (savedPosition) {
          window.setTimeout(() => window.scrollTo(...savedPosition), 50);
        } else {
          window.setTimeout(() => window.scrollTo(0, 0), 50);
        }
      }
    } else {
      // Direct URL navigation (e.g., from an external link or refreshing the page)
      // Let the browser handle scrolling to the hash
      return true;
    }
  
    return false;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.GATSBY_ENVIRONMENT !== 'prod') return
  if (!prevLocation) return // initial load already handled by the head snippet
  window.dataLayer = window.dataLayer || []
}